export default {
      id: "averses-de-pluie-faible-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#averses-de-pluie-faible-usage",
      toString: function () {
        return this.url;
      }
    }